import React from 'react';
import classNames from 'classnames';
import bowser from 'yola-bowser';

const ActionList = ({
  children,
  separateItems = true,
  withMobileBorder = false,
  ...otherProps
}) => {
  const isMobile = bowser.mobile;

  const classes = classNames('ws-ui-action-list', {
    'ws-ui-action-list--mobile': isMobile,
    'ws-ui-action-list--separate-items': separateItems,
    'ws-ui-action-list--with-border': !isMobile || withMobileBorder,
  });

  return (
    <div className={classes} {...otherProps}>
      {children}
    </div>
  );
};

export default ActionList;
